






import ProductList from './components/ProductList/ProductList.vue';

export default {
  name: "App",
  components: {
    ProductList,
  },
}
